// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--aBySN","arrow":"_93444fe79c--arrow--Be39q","arrow-left":"_93444fe79c--arrow-left--omSwT","closer":"_93444fe79c--closer--gshJh"};